var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusDraft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#00B2A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.64006L22.41 9.05006C22.2624 8.91522 22.0896 8.81083 21.9016 8.74286C21.7136 8.6749 21.514 8.6447 21.3143 8.65399C21.1145 8.66327 20.9186 8.71187 20.7377 8.797C20.5568 8.88212 20.3945 9.0021 20.26 9.15006L9.76001 19.6501L8.70001 23.3501L12.4 22.2901L22.9 11.7901C23.048 11.6556 23.168 11.4933 23.2531 11.3124C23.3382 11.1315 23.3868 10.9355 23.3961 10.7358C23.4054 10.5361 23.3752 10.3365 23.3072 10.1485C23.2392 9.96045 23.1349 9.78768 23 9.64006Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85946 20L9 23L12 22.1405L9.85946 20Z",
    fill: "#00B2A9",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 9.87012L22.13 14.1001",
    stroke: "#00B2A9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDraft);
export default __webpack_public_path__ + "static/media/status-draft.559351804b69636e68820dc2e1883506.svg";
export { ForwardRef as ReactComponent };